const AlertStatus = ({ alert: { isSending, activeForEmails, activeForAppNotifications } }) => {
  const textColor = isSending ? "tw-text-teal" : "tw-text-coral";
  const statusText = createStatusText(isSending, activeForEmails, activeForAppNotifications);

  return (
    <>
      <span className="tw-text-[12px] tw-text-gray-50 tw-font-semibold">Status:</span>
      <span className={`tw-text-[12px] tw-font-semibold ${textColor}`}>{statusText}</span>
    </>
  );
};

export default AlertStatus;

const createStatusText = (isSending, activeForEmails, activeForAppNotifications) => {
  if (!isSending) {
    return "Not Sending Alerts";
  }

  if (activeForEmails && activeForAppNotifications) {
    return "Sending Alerts";
  }

  return activeForEmails ? "Sending Email Alerts" : "Sending Home App Alerts";
};
